<template>
    <div class="inline-flex">
        <modal id="modalSocialShare" @close="close" v-if="showModal">
            <template #header>
                Share Chart With
            </template>
            <template #body>
                <div class="py-4">
                    <div class='flex items-center'>
                        <div @click="onClick('twitter')" class='flex-1 text-center'><i class="fab fa-twitter"></i></div>
                        <div @click="onClick('facebook')" class='flex-1 text-center'><i class="fab fa-facebook"></i></div>
                        <div @click="onClick('linkedin')" class='flex-1 text-center'><i class="fab fa-linkedin"></i></div>
                        <div @click="onClick('copyLink')" class='flex-1 text-center'><i class="fas fa-link"></i></div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const emit = defineEmits(['socialShare', 'close']);

const showModal = ref(false);

function openModal() {
    showModal.value = true;
}

function onClick(pAction) {
    emit('socialShare', pAction);
    close();
}

function close() {
    showModal.value = false;
}

defineExpose({
    openModal
});
</script>

<style lang="scss">
#modalSocialShare {
    .modal-container {
        width: 24rem;
        @screen xs {
            width: 100%;
        }
    }
    .modal-body{
        i {
            @apply text-3xl cursor-pointer;

            &.fa-facebook {
                color: #3b5998;
            }

            &.fa-twitter {
                color: #00acee;
            }

            &.fa-linkedin {
                color: #0077b5;
            }

            &.fa-link {
                color: #777;
            }
        }
    }
}
</style>
